import React from 'react';
import FeedBacks from '../../../common/feedback/index'

export default function AdminFeedBacks(){

  return <FeedBacks/>
}
